export const MOCK_DEPLOYMENTS_DATA = [
  {
    id: 'dep-001',
    name: 'Acme Corp – Plant North',
    client: 'Acme Corp',
    location: 'Plant North',
    status: 'active',
    plantType: 'Blast Furnace',
    createdAt: '2025-11-01T09:00:00Z',
    updatedAt: '2026-05-10T14:23:00Z',
    userCount: 3,
    alertCount: 2,
  },
  {
    id: 'dep-002',
    name: 'Acme Corp – Plant South',
    client: 'Acme Corp',
    location: 'Plant South',
    status: 'active',
    plantType: 'Cellhouse',
    createdAt: '2025-12-15T10:00:00Z',
    updatedAt: '2026-05-18T08:10:00Z',
    userCount: 2,
    alertCount: 0,
  },
  {
    id: 'dep-003',
    name: 'Globex Industries – Unit A',
    client: 'Globex Industries',
    location: 'Unit A',
    status: 'provisioning',
    plantType: 'Smelter',
    createdAt: '2026-04-20T11:00:00Z',
    updatedAt: '2026-05-20T16:45:00Z',
    userCount: 1,
    alertCount: 0,
  },
];

export function getDeploymentById(id) {
  return MOCK_DEPLOYMENTS_DATA.find((d) => d.id === id) ?? null;
}
